import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventDropdownComponent } from '../components/event-dropdown/event-dropdown.component';

@NgModule({
  declarations: [
    EventDropdownComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NgSelectModule
  ],
  exports: [
    EventDropdownComponent
  ]
})
export class EventDropdownModule {}
